import {
	Box,
	Button,
	VStack,
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	HStack,
	Text,
} from 'src/components/ui';
import { ChevronDownIcon } from '@chakra-ui/icons';
import React, { useState } from 'react';
import AutoAssignIcon from 'src/assets/svgs/auto-assign-icon.svg';
import GalleryIcon from 'src/assets/svgs/gallery-icon.svg';
import SelectTemplateModal from './SelectTemplateModal';

interface GenerateOrSelectCardProps {
	onGenerate: () => void;
	campaignId: string;
	handleRefreshDesignDirections: () => Promise<void>;
	setIsGeneratingDD: React.Dispatch<React.SetStateAction<boolean>>;
	setIsGeneratingFromModal?: React.Dispatch<React.SetStateAction<boolean>>;
	triggerPollingForNewGeneration?: () => void;
	isDisabled?: boolean;
	source?: 'campaignForm' | 'designDirections';
	handleNavigateToStep2?: () => void;
}

const GenerateOrSelectCard = ({
	onGenerate,
	handleRefreshDesignDirections,
	setIsGeneratingDD,
	setIsGeneratingFromModal,
	triggerPollingForNewGeneration,
	campaignId,
	isDisabled = false,
	source = 'designDirections',
	handleNavigateToStep2,
}: GenerateOrSelectCardProps) => {
	const [isModalOpen, setModalOpen] = useState(false);
	const handleOpenModal = () => {
		console.log('📂 [GenerateOrSelectCard] Opening template gallery modal');
		setModalOpen(true);
	};

	const handleAutoAssign = () => {
		console.log('🎯 [GenerateOrSelectCard] Auto assign clicked!', {
			isDisabled,
			campaignId,
		});
		onGenerate();
	};

	const handleCloseModal = (isGenerating = false) => {
		setModalOpen(false);
		// Reset the modal generation flag ONLY if user closes without generating
		if (setIsGeneratingFromModal && !isGenerating) {
			setIsGeneratingFromModal(false);
		}
	};

	return (
		<Box>
			<VStack spacing={4} w="full">
				<HStack spacing={0}>
					<Menu placement="bottom-end">
						<MenuButton
							as={Button}
							size="md"
							px={4}
							py={2}
							fontSize="sm"
							variant="orangeSolid"
							borderRightColor={'whiteAlpha.900'}
							rightIcon={
								<ChevronDownIcon
									boxSize={5}
									justifyContent="center"
									alignContent="center"
								/>
							}
							isDisabled={isDisabled}
							opacity={isDisabled ? 0.6 : 1}
							cursor={isDisabled ? 'not-allowed' : 'pointer'}
							pointerEvents={isDisabled ? 'none' : 'auto'}
							_hover={isDisabled ? {} : { opacity: 0.9 }}
						>
							Add design
						</MenuButton>
						<MenuList zIndex="popover">
							<MenuItem
								onClick={handleAutoAssign}
								icon={
									<img
										src={AutoAssignIcon}
										alt="Auto Assign Icon"
										width={20}
										height={20}
									/>
								}
								isDisabled={isDisabled}
							>
								<Text fontSize="16px" fontFamily="Noto Sans" color="#4B5563">
									Auto assign design
								</Text>
							</MenuItem>
							<MenuItem
								onClick={handleOpenModal}
								icon={
									<img
										src={GalleryIcon}
										alt="Gallery Icon"
										width={20}
										height={20}
									/>
								}
								isDisabled={isDisabled}
							>
								<Text fontSize="16px" fontFamily="Noto Sans" color="#4B5563">
									Select from the gallery
								</Text>
							</MenuItem>
						</MenuList>
					</Menu>
				</HStack>
			</VStack>
			{isModalOpen && (
				<SelectTemplateModal
					isOpen={isModalOpen}
					onClose={(isGenerating) => handleCloseModal(isGenerating)}
					header="Template Gallery"
					size="80%"
					handleRefreshDesignDirections={handleRefreshDesignDirections}
					isTemplateModal={true}
					setIsGeneratingDD={setIsGeneratingDD}
					setIsGeneratingFromModal={setIsGeneratingFromModal}
					triggerPollingForNewGeneration={triggerPollingForNewGeneration}
					source={source}
					onSubmit={source === 'campaignForm' ? onGenerate : undefined}
					handleNavigateToStep2={handleNavigateToStep2}
				/>
			)}
		</Box>
	);
};

export default GenerateOrSelectCard;
